import React from 'react';

const BusinessNeed = (props) => {
    return (
        <section className="business-need">
            <div className="w-100 bg-indigo text-center">
                <h2 className="m-0">ExeSIM Fleet has all the features your business needs</h2>
                <p className="m-0 bold">Our SIM-only plans include: </p>
            </div>
            <div className="row">
                <div className="col-md-10 col-md-offset-1 centered">
                    <div className="d-flex bn-wrapper">
                        {props.data.business_need && props.data.business_need.map((item, index) => {
                            return (
                                <div className="needs-container" key={index}>
                                    {item.column.map((item, index) => {
                                        return (
                                            <div className="mb-4" key={index}>
                                                <h5 className="m-0 bold" dangerouslySetInnerHTML={{ __html: item.title }} />
                                                <p className="m-0" dangerouslySetInnerHTML={{__html: item.content}} />
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })}
                    </div>   
                </div>
            </div>
        </section>
    )
}
export default BusinessNeed


// WEBPACK FOOTER //
// ./resources/assets/js/modules/mobileFleet/BusinessNeed.js